/* global axios */
import ApiClient from './ApiClient';

class SmartsAPI extends ApiClient {
  constructor() {
    super('smarts', { accountScoped: true });
  }
  search(search) {
    return axios.post(`${this.url}/search`, {
      search: search,
    });
  }
}

export default new SmartsAPI();
